<template>
  <div class="redactor-wrapper">
    <textarea
      :ref="refId"
      :name="name"
      :placeholder="placeholder"
      v-model="value"
    />
  </div>
</template>

<script>
import 'vendor/redactor2/redactor.js'
import { uuid } from '@/core/helpers'
export default {
  name: 'Redactor',
  data() {
    return {
      loopFn: null,
      config: {},
      redactor: false,
      defaultPlugins: ['cleanformat', 'fontsize', 'fontfamily'],
      defaultButtons: ['bold', 'italic', 'underline']
    }
  },
  props: {
    value: {
      default: '',
      type: String
    },
    placeholder: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    customConfig: {
      default: () => {},
      type: Object
    },
    plugins: {
      type: Array,
      default: () => [],
      required: false
    },
    buttons: {
      type: Array,
      default: () => [],
      required: false
    },
    useDefaultButtons: {
      type: Boolean,
      default: true
    },
    useDefaultPlugins: {
      type: Boolean,
      default: true
    },
    dataQa: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.config = { ...this.customConfig }
    this.config.buttons = [
      ...(this.useDefaultButtons ? this.defaultButtons : []),
      ...this.buttons
    ]
    this.config.plugins = [
      ...(this.useDefaultPlugins ? this.defaultPlugins : []),
      ...this.plugins
    ]
  },
  mounted() {
    this.init()
    this.$nextTick(() => {
      const editorEl = this.$el.querySelector('[contenteditable="true"]')
      if (editorEl && this.dataQa) {
        editorEl.setAttribute('data-qa', this.dataQa)
      }

      if (this.disabled) {
        editorEl.removeAttribute('contenteditable="true"')
        editorEl.setAttribute('contenteditable', false)
        editorEl.classList.add('redactor-toolbar-disabled')
        const toolbar = this.$el.querySelector('.redactor-toolbar')
        if (toolbar) toolbar.classList.add('redactor-toolbar-disabled')
      }
    })
  },
  computed: {
    refId() {
      return `redactor-${uuid()}`
    }
  },
  beforeDestroy() {
    this.destroy()
  },
  methods: {
    init() {
      const callbacks = {
        change: html => {
          this.handleInput(html)
          return html
        },
        focus: e => {
          this.handleInput($(this.$refs[this.refId]).redactor('code.get'))
          return e
        }
      }

      // extend config
      if (typeof this.config.callbacks === 'undefined') {
        this.$set(this.config, 'callbacks', callbacks)
      } else {
        this.config.callbacks.focus = callbacks.focus
        this.config.callbacks.change = callbacks.change
      }

      // call Redactor
      const app = $(this.$refs[this.refId]).redactor(this.config)
      // set instance
      this.redactor = app
      this.$parent.redactor = app

      // Workaround for live reload. XP-5802
      if (this.config.plugins.includes('source')) {
        this.loopFn = setInterval(() => {
          this.handleInput($(this.$refs[this.refId]).redactor('code.get'))
        }, 200)
      }
    },
    destroy() {
      clearInterval(this.loopFn)
      $(this.$refs[this.refId]).redactor('core.destroy')
      this.redactor = null
      this.$parent.redactor = null
    },
    handleInput(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style scoped lang="scss">
.redactor-wrapper {
  /deep/ .redactor-toolbar {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border: 1px solid #dcdfe6;
    visibility: visible !important;
    position: relative !important;
    width: auto !important;
    top: 0px !important;
    left: 0px !important;
    z-index: 1;
  }

  /deep/ .redactor-layer {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border: 1px solid #dcdfe6;
    border-top: none;
  }

  /deep/ .redactor-disabled {
    background: #f5f7fa !important;
    color: #a8a8a8 !important;
    cursor: not-allowed !important;
    user-select: none !important;
    padding: 10px;
  }

  /deep/ .redactor-toolbar-disabled {
    pointer-events: none !important;
    opacity: 0.4 !important;
  }
}
/deep/ .personalizationPopup,
/deep/ .snippetPopup {
  display: none;
  position: absolute;
  width: 300px;
  left: auto !important;
  top: 35px;
  overflow: hidden;
  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.25);
  margin: 2px;
  background: #fff;
  min-width: 150px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  padding: 12px;
  //z-index: 2000;
  color: #606266;
  line-height: 1.4;
  text-align: justify;
  font-size: 14px;
  word-break: break-all;
}

/deep/ .emojisEditor .emojisPopup {
  display: none;
  position: absolute;
  z-index: 2002;
  width: 310px;
  right: -1px;
  top: 35px;
  overflow: hidden;
  background: white;
}

/deep/ .snippet-text-editor textarea {
  margin: 0 !important;
  border: 1px solid #c2c4c6;
}

/deep/ .contentEditor {
  position: relative;
}

/deep/ .emojisEditor .emojisPopup {
  display: none;
  position: absolute;
  z-index: 2002;
  width: 310px;
  right: -1px;
  top: 35px;
  overflow: hidden;
  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.25);
  background: #fff;
}

/deep/ .emojisEditor .emojisPopup .emojisMenu {
  background: #eaeaea;
}

/deep/ .emojisEditor .emojisPopup .emojisItem {
  display: inline-block;
  font-size: 16px;
  text-align: center;
  width: 30px;
  margin: 4px;
  cursor: pointer;
}

/deep/ .emojisEditor .emojisPopup .emojisCategory {
  height: 160px;
  overflow-x: hidden;
  overflow-y: auto;
}

/deep/ .emojisEditor .emojisPopup .emojisTitle {
  margin: 4px;
  font-weight: 700;
  color: #666;
}

/deep/ .emojisEditor .emojisPopup .emojisItem {
  display: inline-block;
  font-size: 16px;
  text-align: center;
  width: 30px;
  margin: 4px;
  cursor: pointer;
}

/deep/ .personalizationEditor .personalizationPopup {
  display: none;
  position: absolute;
  z-index: 2002;
  width: fit-content;
  right: -1px;
  top: 35px;
  overflow: hidden;
  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.25);
  margin: 2px;
  background: #fff;
}

/deep/ .personalizationEditor .personalizationPopupRemoveButton {
  position: absolute;
  top: 6px;
  right: 6px;
  font-size: 16px;
  cursor: pointer;
}
/deep/ .personalizationEditor .personalizationPopupRemoveButton {
  position: absolute;
  top: 6px;
  right: 6px;
  font-size: 16px;
  cursor: pointer;
}

/deep/ .contentEditor.snippetEditor textarea {
  height: 200px;
  width: 100%;
  box-sizing: border-box;
}

/deep/ input[type='email'],
/deep/ input[type='number'],
/deep/ input[type='password'],
/deep/ input[type='search'],
/deep/ input[type='text'],
/deep/ input[type='url'] {
  background: #fff;
  cursor: text;
  outline: none;
  min-width: 250px;
  -webkit-appearance: none;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266 !important;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  padding: 0 15px !important;
}

/deep/ .snippetEditor .snippetPopup {
  display: none;
  position: absolute;
  z-index: 2002;
  width: fit-content;
  right: -1px;
  top: 35px;
  overflow: hidden;
  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.25);
  padding: 12px;
  background: #fff;
}

/deep/ .contentEditor .contentEditorToolbar {
  position: absolute;
  z-index: 1100;
  top: 1px;
  right: 15px;
  height: 50px;
  width: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 0 !important;
}
/deep/ .contentEditor .contentEditorToolbar i {
  color: #111;
  cursor: pointer;
  font-size: 12px;
}

/deep/ .contentEditor .contentEditorToolbar span {
  color: #111;
  cursor: pointer;
  font-size: 15px;
}

/deep/ .icon {
  /deep/ .contenteditor.contented {
    display: inline-block;
  }
  overflow: hidden;
}

/deep/ .snippetEditor .snippetPopupRemoveButton {
  position: absolute;
  top: 6px;
  right: 6px;
  font-size: 16px;
  cursor: pointer;
}

/deep/ input:hover[type='password'],
/deep/ input:hover[type='text'],
/deep/ select:hover,
/deep/ textarea:hover {
  border-color: #1d87c8 !important;
}

/deep/ .stdTextarea {
  display: block;
  margin: 0;
  background: #fff;
  border: 1px solid #ccc;
  outline: none;
  color: #717782;
  font-size: 16px;
  font-weight: 300;
  line-height: 22px;
}
/deep/ textarea {
  width: 100%;
  resize: vertical;
  max-height: 300px;
  min-height: 200px;
  background: rgba(0, 0, 0, 0.7);
  border: none;
  padding: 10px;
  margin: 10px 0;
  font: 12pt/12pt Open Sans, sans-serif;
}
>>> .label1 {
  color: #5c6374;
  font-size: 14px;
  margin-bottom: 5px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/common/components/Redactor.vue